module.exports = __webpack_public_path__ + "img/analytic120 4.f0a9bc51.svg";